import { render, staticRenderFns } from "./cashRegister.vue?vue&type=template&id=18d8ab18&"
import script from "./cashRegister.vue?vue&type=script&lang=js&"
export * from "./cashRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports